import React from 'react'
import { Tabs } from '@material-ui/core'
import { StyledTab } from './styled'
import { Space } from '../../layouts'
import { IOption } from '../../types/common'
import { getTab, setSearch } from '../../services/views'

export interface ITabsHead {
  tabs: Array<IOption & { icon: any }>
  location: Location
  history: { push(options: object): void }
}

export const TabsHead = ({ tabs = [], location, history }: ITabsHead) => (
  <Space mb={4}>
    <Tabs
      id="tabs-head"
      value={getTab(location)}
      onChange={(_, newTab: string): void => {
        history.push(setSearch(location, { tab: newTab }))
      }}
    >
      {tabs.map((props: IOption) => (
        <StyledTab key={props.value} id={props.value} {...props} />
      ))}
    </Tabs>
  </Space>
)
